import { cx } from '../cx';

const SHAPE = { line: 'h-3 rounded-jc-info', block: 'rounded-jc-info', circle: 'rounded-full' } as const;

export type SkeletonProps = {
  shape?: keyof typeof SHAPE;
  /** Size it like the content it stands in for (e.g. "h-4 w-40", "size-10"). */
  className?: string;
};

/**
 * A placeholder in the exact shape of loading content, pulsing gently (static under reduced motion).
 * Hidden from assistive tech: announce loading once with a live region instead.
 */
export function Skeleton({ shape = 'line', className }: SkeletonProps) {
  return <span aria-hidden className={cx('block bg-jc-skeleton motion-safe:animate-pulse', SHAPE[shape], className)} />;
}
